import { connect, Dispatch } from 'react-redux';

import { AppState } from '../../..';
// import { ContractViewModel } from '@models/Contract';
import {
  // saveEscrowInfo,
  searchEscrowOfficers,
  loadEscrowOfficer,
  loadTransactionCoordinator,
  searchTransactionCoordinators,
  clearEscrowOfficer,
  removeTxC,
  getAssetManagers,
  saveCoeDate
} from '../../contract.actions';
import { EscrowInfoComponent, EscrowInfoProperties } from './escrow-info.component';
import { getEscrowOfficer } from '../../../escrow-officer/escrow-officer.actions';
import { ModalProps } from '@common/components/modal';
import { toggleModal } from '@common/components/common.actions';
import {
  getTransactionCoordinator,
  GetTransactionCoordinatorSuccessAction
} from '../../../transaction-coordinator/transaction-coordinator.actions';
import { actions } from 'react-redux-form';
import FormNames from '@constants/FormNames.enum';
import { getContractResaleData } from 'src/contract/contract-resale.actions';
import { GetPriceAdjustmentMetadata } from '@models/Product';
import { blankStatesVM } from '@models/common.models';
import {
  getProductGroups,
  triggerGetProducts,
  triggerGetPriceAdjustments,
  triggerGetCoverageOptions,
  getEmployeeDiscount,
  setSellersCoverage,
  updateSelections,
  updateTotalPrice
} from '../coverage';
import { isSellersCoverageRequiredState } from '@common/validators';

// This is used to translate the state of the page to the props on the component
function mapStateToProps(
  state: AppState,
  ownProps: {
    // buttonRef: (button: HTMLButtonElement) => void;
    // next: Function;
    // currentStep: number;
    model: string;
    isOrderEdit?: boolean;
  }
): Partial<EscrowInfoProperties> {
  const contractVM = state.contract.contractVM;
  return {
    message: state.contract.message,
    // currentStep: ownProps.currentStep,
    model: ownProps.model,
    contractVM: state.contract.contractVM!,
    escrowOfficer: state.contract.escrowOfficer ? state.contract.escrowOfficer : undefined,
    escrowOffice: state.contract.escrowOffice ? state.contract.escrowOffice : undefined,
    transactionCoordinators: state.contract.contractVM!.transactionCoordinatorIds,
    assetManagers: state.contract.assetManagers,
    isOrderEdit: ownProps.isOrderEdit,
    isOpenContract: state.contract.isOpenContract,
    priceAdjustmentMetaData: ({
      hasPropertyManagement: state.contract.propertyManager !== undefined,
      hasAgent: contractVM ? state.contract.contractVM!.initAgentId !== undefined : false,
      customerId: contractVM!.buyerId,
      stateAbbreviation: contractVM ? contractVM!.propertyAddress.state || blankStatesVM : blankStatesVM,
      zipCode: contractVM!.propertyAddress.zip,
      hasEmployeeDiscounts: false
    } as any) as GetPriceAdjustmentMetadata
  };
}

// This should create proxy wrappers for actions used by the component
function mapDispatchToProps(
  dispatch: Dispatch<AppState>
  // ownProps: { buttonRef: (button: HTMLButtonElement) => void; next: Function }
): Partial<EscrowInfoProperties> {
  return {
    getAssetManagers: () => {
      dispatch(getAssetManagers());
    },
    toggleModal: (modalProps: ModalProps) => {
      dispatch(toggleModal(modalProps));
    },
    lookupEscrowOfficer(value: string, id: number) {
      return searchEscrowOfficers(value, id);
    },
    // lookupEscrowOfficer: searchEscrowOfficers,
    onEscrowOfficerSelect: (model: string, value: number) => {
      dispatch(getEscrowOfficer(value, loadEscrowOfficer));
    },
    clearEscrowOfficer: () => {
      dispatch(clearEscrowOfficer());
      dispatch(actions.change(FormNames.AffiliatesInfoForm + '.escrowOfficerId', 0));
      dispatch(actions.change(FormNames.AffiliatesInfoForm + '.escrowId', 0));
    },
    lookupTransactionCoordinator(value: string, id: number) {
      return searchTransactionCoordinators(value, id);
    },
    // lookupTransactionCoordinator: searchTransactionCoordinators,
    onTransactionCoordinatorSelect: (model: string, value: number) => {
      dispatch(getTransactionCoordinator(value, loadTransactionCoordinator));
    },
    removeTxC: (id: number) => {
      dispatch(removeTxC(id));
    },
    getTransactionCoordinator: (id?: number) => {
      return dispatch(getTransactionCoordinator(id)).then((action: GetTransactionCoordinatorSuccessAction) => {
        dispatch(actions.change(FormNames.TransactionCoordinatorForm, action.txCoordinator));
      });
    },
    getContractResaleData: (id: number, date: Date) => {
      dispatch(getContractResaleData(id, date, true));
    },
    saveCoe: (coeDate: Date) => {
      dispatch(saveCoeDate(coeDate));
    },
    handleEditChange: (
      adjustmentMetaData: GetPriceAdjustmentMetadata,
      propertyTypeId: number,
      saleTypeId: number,
      isRenewal: boolean
    ) => {
      let dropdownsPromise = Promise.all([
        dispatch(getProductGroups(adjustmentMetaData.zipCode, propertyTypeId, saleTypeId)),
        dispatch(triggerGetProducts(propertyTypeId, saleTypeId, isRenewal)),
        dispatch(triggerGetPriceAdjustments(adjustmentMetaData)),
        dispatch(triggerGetCoverageOptions(isRenewal))
      ]);

      if (adjustmentMetaData.customerId) {
        dispatch(getEmployeeDiscount(adjustmentMetaData.customerId));
      }
      if (isSellersCoverageRequiredState(adjustmentMetaData.stateAbbreviation)) {
        dispatch(setSellersCoverage(true));
      }

      dropdownsPromise.then(() => {
        return dispatch(updateSelections()).then(() => {
          dispatch(updateTotalPrice());
        });
      });
      let dropdownsPromisePA = Promise.all([
        dispatch(triggerGetPriceAdjustments(adjustmentMetaData)),
        dispatch(triggerGetCoverageOptions(isRenewal))
      ]);

      if (adjustmentMetaData.customerId) {
        dispatch(getEmployeeDiscount(adjustmentMetaData.customerId));
      }
      dropdownsPromisePA.then(() => {
        return dispatch(updateSelections()).then(() => {
          dispatch(updateTotalPrice());
        });
      });
    }
  };
}

// Connect function "wires" both of the map functions and returns a wrapper container for the component
export const EscrowInfo = connect(
  mapStateToProps,
  mapDispatchToProps
)(EscrowInfoComponent);



// WEBPACK FOOTER //
// ./src/contract/_components/escrow-info/escrow-info.container.tsx